export const MODULE_NAME = 'integrations/ads'
export const ADS_EVENT = 'ads_event'
